<!--
  -  Copyright (c) Qwoach LLC 2022. All rights reserved.
  -  Unauthorized copying of this file, via any medium is strictly prohibited
  -  Proprietary and confidential
  -  Created by Artem Bogush <artem@qwoach.com> on 3/3/2022
  -->

<template>
	<div v-bind="attrsStylesClass">
		<qw-form :model="model" ref="mainForm">

			<FormRow v-for="(emailReminder, index) in emailReminders" :key="emailReminder.id"
					 class="mb-5 input-no-error reminder-error-padding"
					 :prop="`emailReminders.${index}`"
					 :rules="{validator: validateEmailReminder, trigger: 'validate'}">
				<div class="row mx-0">
					<FormTextRow
						:readonly="readonly"
						class="mr-3"
						style="display: inline-block"
						v-model="emailReminder.title"
						placeholder="Message name">

					</FormTextRow>


					<div class="card col-lg mr-0">

						<div class="row-lg mx-0 align-items-center flex-nowrap">
							<!--									<div class="text-muted">-->
							<div class="pr-2 qw-row">
								<div class="layout-spacer">When to send:</div>
								<qw-button-icon
									v-if="!readonly"
									:style="{opacity: index > 0 ? 1 : 0}" :disable="index === 0"
									type="circle" icon="icon-trash"
									@click="onEmailReminderDeleteClicked(index)"/>


							</div>
							<div class="qw-row-md mb-2">

								<div class="qw-row">
									<FormNumberRow
										v-show="emailReminder.trigger.shiftDirection !== 0"
										:readonly="readonly"
										:class="{'mt-1': !readonly}"
										:returnOptionValue="true"
										v-model="emailReminder.trigger.shiftBaseAmount">
									</FormNumberRow>
									<FormSelectRow
										:readonly="readonly"
										v-show="emailReminder.trigger.shiftDirection !== 0"
										style="width: 7.5rem;"
										:class="{'mt-1': !readonly}"
										class="pr-2"
										:options="reminderOptions"
										:returnOptionValue="true"
										v-model="emailReminder.trigger.shiftUnits">
									</FormSelectRow>
								</div>
								<!--									:readonly="true"-->
								<!--									:class="{'pt-3' : !true}"-->
								<FormSelectRow
									:readonly="readonly"
									style="width: 15rem;"
									:class="{'mt-1': !readonly}"
									:options="reminderOptionsDirections"
									:returnOptionValue="true"
									@change="() => emailReminderDirectionChanged(emailReminder)"
									v-model="emailReminder.trigger.shiftDirection">
								</FormSelectRow>
								<!--										session {{ emailReminder.trigger.shiftDirection > 0 ? "end" : "start" }}-->
								<!--									</div>-->

								<qw-link-button
									class="ml-lg-5 mt-2 mt-lg-0"
									@click="emailReminder._isPersonalizationShowing = !emailReminder._isPersonalizationShowing">
									<span v-html="getReminderMessageText(emailReminders)"/>
								</qw-link-button>

							</div>

						</div>


						<div v-if="isEmailReminderEnabled && emailReminder._isPersonalizationShowing"
							 class="my-4">
							<EmailTemplateComposer
								:readonly="readonly"
								v-model="emailReminders[index]"
								:analytics-props="analyticsPropsMethod()"
								:input-debounce-delay="inputDebounceDelay"
								@change="valueChanged('Email reminder message')"/>
<!--								:defaultSubject="index === 0 ? reminderDefaultSubject : null"-->
<!--								:defaultBody="index === 0 ? reminderDefaultBody : null"/>-->
						</div>
					</div>
				</div>

			</FormRow>

			<div class="my-4" v-if="!readonly">
				<a
					href="#"
					class=""
					@click.prevent="onAddEmailClicked"> Add another email
				</a>
			</div>
		</qw-form>

	</div>
</template>

<script>
import BaseComponent from "@/core/components/BaseComponent.vue";
import FormRow from "@/core/components/Form/Base/FormRow.vue";
import EmailTemplateComposer from "@/core/components/template/EmailTemplateComposer.vue";
import FormTextRow from "@/core/components/Form/FormTextRow.vue";
import FormNumberRow from "@/core/components/Form/FormNumberRow.vue";
import FormSelectRow from "@/core/components/Form/FormSelectRow.vue";
import {
	defaultReminderBody,
	defaultReminderSubject
} from "@shared/scheduler/reminders/EmailReminderItem";
import {fixTags, validateTags} from "@/utils/helpers";
import {createDialogLazy} from "@/utils/helpers-external.js";
import {tagsAll} from "@/core/components/template/PlaceholdersData";
let PersonalizationTagsErrorDialog = () => import("@/core/components/Dialogs/PersonalizationTagsErrorDialog.vue");

let personalizationTagsErrorDialog = createDialogLazy(PersonalizationTagsErrorDialog)

export default {
	name: "RemindersWorkflowView",
	components: {PersonalizationTagsErrorDialog, FormSelectRow, FormNumberRow, FormTextRow, EmailTemplateComposer, FormRow},
	extends: BaseComponent,
	inheritAttrs: false,

	props: {
		emailReminders: {Array, required: true},
		inputDebounceDelay: {Number, default: 1000},
		isEmailReminderEnabled: {Boolean, default: true},
		readonly: Boolean
	},


	watch: {
		emailReminders() {
			this.setupModel()
		}
	},

	data() {
		return {
			model: null,
			reminderOptions: [],
			reminderOptionsDirections: [],
		}
	},

	created() {
		this.setupModel()
		this.setupReminderOptions()
	},

	methods: {

		setupModel(){
			this.model = {emailReminders: this.emailReminders}
		},

		emailReminderDirectionChanged(reminder) {
			this.$emit('emailReminderDirectionChanged', reminder, this.emailReminders)
		},

		onEmailReminderDeleteClicked(index) {
			this.$emit('onEmailReminderDeleteClicked', index, this.emailReminders)
		},

		valueChanged(message) {
			this.$emit('valueChanged', message, this.emailReminders)
		},

		onAddEmailClicked() {
			this.$emit('onAddEmailClicked', this.emailReminders)
		},


		async validateEmailReminder(rule, emailReminder, callback) {
			console.log("emailReminderValidator: emailReminder = ", emailReminder)
			let error
			let hasReminderWithSameTime = this.hasReminderWithSameTime(emailReminder)
			if (!emailReminder.subject && !emailReminder.body) {
				error = "Please feel in email subject and body or remove this email from the sequence."
				emailReminder._isPersonalizationShowing = true
			} else if (!emailReminder.subject) {
				error = "Please feel in email subject."
				emailReminder._isPersonalizationShowing = true
			} else if (!emailReminder.body) {
				error = "Please feel in email body."
				emailReminder._isPersonalizationShowing = true
			} else if (hasReminderWithSameTime) {
				error = "This email has the same send time as another email in this sequence. Please change the send time or remove this email."
			}
			if(!error){
				emailReminder.body = fixTags(emailReminder.body)
				let res = await validateTags(emailReminder.body, {validTags: tagsAll}, async (invalidTags)=>{
					await personalizationTagsErrorDialog({invalidTags})
				})
				if(!res){
					error = "Some tags has typos. Please use 'Personalize' dropdown to correct."
				}
			}
			console.log("emailReminderValidator: error = ", error)
			callback(error)
		},

		hasReminderWithSameTime(emailReminder) {
			let reminderTriggerShift = emailReminder.trigger.getTriggerShift()
			for (let reminder of this.emailReminders) {
				if (reminder === emailReminder || (emailReminder.id && reminder.id === emailReminder.id)) {
					// We only check all reminders before this one.
					// As soon as we meet this one in the array, we stop.
					return false
				}

				if (reminderTriggerShift === reminder.trigger.getTriggerShift()) {
					return true
				}
			}
			console.log("hasReminderWithSameTime: nothing found")
			return false
		},

		getReminderMessageText(emailReminder) {
			return emailReminder._isPersonalizationShowing ? this.hideMessageText : this.showMessageText
		},

		setupReminderOptions() {
			let oneMinute = 60 * 1000
			let oneHour = 60 * oneMinute
			this.reminderOptions = [
				// {label: 'minute(s)', value: oneMinute},
				{label: 'hour(s)', value: oneHour},
				{label: 'day(s)', value: 24 * oneHour},
			]
			this.reminderOptionsDirections = [
				{label: 'when session is booked', value: 0},
				{label: 'before session starts', value: -1},
				{label: 'after session ends', value: 1},
			]
		},
	},

	computed: {
		// reminderDefaultSubject() {
		// 	return defaultReminderSubject
		// },
		// reminderDefaultBody() {
		// 	return defaultReminderBody
		// },

		hideMessageText() {
			return this.readonly ? "Hide&nbsp;text" : "Hide&nbsp;editor"
		},
		showMessageText() {
			return this.readonly ? "Show&nbsp;text" : "Edit&nbsp;message"
		}
	},
}
</script>

<style lang="scss">

</style>
